module.exports = __webpack_public_path__ + "static/img/knowledgenew2.9904fee3.png";